import { useMemo } from "react";
export const useKPIFiltering = (interactions, kpi) => {
    return useMemo(() => {
        if (!kpi || !interactions.length)
            return interactions;
        return interactions.filter((interaction) => {
            if (kpi.filters.originators && kpi.filters.originators.length > 0) {
                if (!interaction.ToFilterOriginator || !kpi.filters.originators.includes(interaction.ToFilterOriginator)) {
                    return false;
                }
            }
            if (kpi.filters.priorities && kpi.filters.priorities.length > 0) {
                if (!interaction.ToFilterPriority || !kpi.filters.priorities.includes(interaction.ToFilterPriority)) {
                    return false;
                }
            }
            if (kpi.filters.reasons && kpi.filters.reasons.length > 0) {
                if (!interaction.ToFilterReason || !kpi.filters.reasons.includes(interaction.ToFilterReason)) {
                    return false;
                }
            }
            if (kpi.filters.controlledTransfersOnly) {
                const action = interaction.InteractionFinalAction || "";
                const normalizedAction = action.replace(/\s+/g, "");
                if (normalizedAction !== "ControlledTransfer") {
                    return false;
                }
            }
            if (kpi.filters.blindTransfersOnly) {
                const action = interaction.InteractionFinalAction || "";
                const normalizedAction = action.replace(/\s+/g, "");
                if (normalizedAction !== "BlindTransfer") {
                    return false;
                }
            }
            if (kpi.filters.handoffTransfersOnly) {
                const action = interaction.InteractionFinalAction || "";
                const normalizedAction = action.replace(/\s+/g, "");
                if (normalizedAction !== "HandoffTransfer") {
                    return false;
                }
            }
            return true;
        });
    }, [interactions, kpi]);
};
export const useKPIResult = (interactions, kpi) => {
    const filteredInteractions = useKPIFiltering(interactions, kpi);
    return useMemo(() => {
        if (!kpi)
            return undefined;
        const totalInteractions = filteredInteractions.length;
        const callbackInteractions = filteredInteractions.filter((interaction) => interaction.CallbackFromMessageIdUtc && interaction.SecureMessageSentUtc);
        const callbackCount = callbackInteractions.length;
        if (callbackCount === 0) {
            return {
                kpiConfig: kpi,
                totalInteractions,
                callbackInteractions: 0,
                excellentCount: 0,
                goodCount: 0,
                acceptableCount: 0,
                poorCount: 0,
                excellentPct: 0,
                goodPct: 0,
                acceptablePct: 0,
                poorPct: 0,
            };
        }
        const callbackTimes = callbackInteractions.map((interaction) => {
            const sentTime = new Date(interaction.SecureMessageSentUtc);
            const callbackTime = new Date(interaction.CallbackFromMessageIdUtc);
            return Math.floor((callbackTime.getTime() - sentTime.getTime()) / (1000 * 60));
        });
        let excellentCount = 0;
        let goodCount = 0;
        let acceptableCount = 0;
        let poorCount = 0;
        callbackTimes.forEach((callbackTimeMinutes) => {
            if (callbackTimeMinutes < kpi.thresholds.excellent) {
                excellentCount++;
            }
            else if (callbackTimeMinutes < kpi.thresholds.good) {
                goodCount++;
            }
            else if (callbackTimeMinutes < kpi.thresholds.acceptable) {
                acceptableCount++;
            }
            else {
                poorCount++;
            }
        });
        const excellentPct = Math.round((excellentCount / callbackCount) * 100);
        const goodPct = Math.round((goodCount / callbackCount) * 100);
        const acceptablePct = Math.round((acceptableCount / callbackCount) * 100);
        const poorPct = Math.round((poorCount / callbackCount) * 100);
        return {
            kpiConfig: kpi,
            totalInteractions,
            callbackInteractions: callbackCount,
            excellentCount,
            goodCount,
            acceptableCount,
            poorCount,
            excellentPct,
            goodPct,
            acceptablePct,
            poorPct,
        };
    }, [filteredInteractions, kpi]);
};
//# sourceMappingURL=useKPIFiltering.js.map